export enum ButtonColor {
    Black = 'black-button',
    White = 'white-button',
}

